import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PaperClipOutlinedSvg from "@ant-design/icons-svg/es/asn/PaperClipOutlined";
import AntdIcon from "../components/AntdIcon";
var PaperClipOutlined = function PaperClipOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PaperClipOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PaperClipOutlined.displayName = 'PaperClipOutlined';
}
export default /*#__PURE__*/React.forwardRef(PaperClipOutlined);